import IconBluesky from '../img/icons/bluesky.png';
import IconBond from '../img/icons/bond.png';
import IconCafe from '../img/icons/cafe.png';
import IconCalendar from '../img/icons/calendar.png';
import IconCarte from '../img/icons/carte.png';
import IconClimatisation from '../img/icons/climatisation.png';
import IconCone from '../img/icons/cone.png';
import IconEmail from '../img/icons/email.png';
import IconErreur from '../img/icons/erreur.png';
import IconKings from '../img/icons/kings.png';
import IconMartineau from '../img/icons/martineau.png';
import IconMeeting16 from '../img/icons/meeting16.png';
import IconMeetings from '../img/icons/meetings.png';
import IconMuted from '../img/icons/muted.png';
import IconNorthvolt from '../img/icons/northvolt.png';
import IconPanierBleu from '../img/icons/panierbleu.png';
import IconPoilievre from '../img/icons/poilievre.png';
import IconReplyall from '../img/icons/replyall.png';
import IconScooter from '../img/icons/scooter.png';
import IconTupperware from '../img/icons/tupperware.png';
import IconVersions from '../img/icons/versions.png';
import IconWetransfer from '../img/icons/wetransfer.png';
import IconZoom from '../img/icons/zoom.png';
import ImageBluesky from '../img/items/bluesky.png';
import ImageBond from '../img/items/bond.png';
import ImageCafe from '../img/items/cafe.png';
import ImageCalendar from '../img/items/calendar.png';
import ImageCarte from '../img/items/carte.png';
import ImageClimatisation from '../img/items/climatisation.png';
import ImageCone from '../img/items/cone.png';
import ImageEmail from '../img/items/email.png';
import ImageErreur from '../img/items/erreur.png';
import ImageKings from '../img/items/kings.png';
import ImageMartineau from '../img/items/martineau.png';
import ImageMeeting16 from '../img/items/meeting16.png';
import ImageMeetings from '../img/items/meetings.png';
import ImageMuted from '../img/items/muted.png';
import ImageNorthvolt from '../img/items/northvolt.png';
import ImagePanierBleu from '../img/items/panierbleu.png';
import ImagePoilievre from '../img/items/poilievre.png';
import ImageReplyall from '../img/items/replyall.png';
import ImageScooter from '../img/items/scooter.png';
import ImageTupperware from '../img/items/tupperware.png';
import ImageVersions from '../img/items/versions.png';
import ImageWetransfer from '../img/items/wetransfer.png';
import ImageZoom from '../img/items/zoom.png';

export default [
    {
        id: 'bluesky',
        label: 'Recommencer ta communauté de 0',
        image: ImageBluesky,
        icon: IconBluesky,
        width: 840,
        height: 840,
    },
    {
        id: 'bond',
        label: 'Rédemption post-cancel',
        image: ImageBond,
        icon: IconBond,
        width: 840,
        height: 840,
    },
    {
        id: 'cafe',
        label: 'Made in china',
        image: ImageCafe,
        icon: IconCafe,
        width: 840,
        height: 840,
    },
    {
        id: 'calendar',
        label: 'Bonne chance pour ton lunch',
        image: ImageCalendar,
        icon: IconCalendar,
        width: 840,
        height: 840,
    },
    {
        id: 'carte',
        label: 'Invitation au post mortem du projet',
        image: ImageCarte,
        icon: IconCarte,
        width: 840,
        height: 840,
    },
    {
        id: 'climatisation',
        label: 'But it’s cold outside',
        image: ImageClimatisation,
        icon: IconClimatisation,
        width: 840,
        height: 840,
    },
    {
        id: 'cone',
        label: 'Léger retard',
        image: ImageCone,
        icon: IconCone,
        width: 840,
        height: 840,
    },
    {
        id: 'email',
        label: 'Non lu(s)',
        image: ImageEmail,
        icon: IconEmail,
        width: 840,
        height: 840,
    },
    {
        id: 'erreur',
        label: 'Les TI sont absents aujourd’hui (formation)',
        image: ImageErreur,
        icon: IconErreur,
        width: 840,
        height: 840,
    },
    {
        id: 'kings',
        label: '6 000 000$',
        image: ImageKings,
        icon: IconKings,
        width: 840,
        height: 840,
    },
    {
        id: 'meeting16',
        label: 'Ça va juste prendre 15 minutes',
        image: ImageMeeting16,
        icon: IconMeeting16,
        width: 840,
        height: 840,
    },
    {
        id: 'meetings',
        label: '(sans titre)',
        image: ImageMeetings,
        icon: IconMeetings,
        width: 840,
        height: 840,
    },
    {
        id: 'muted',
        label: "On t'entend pas",
        image: ImageMuted,
        icon: IconMuted,
        width: 840,
        height: 840,
    },
    {
        id: 'replyall',
        label: 'Bien reçu, merci!!',
        image: ImageReplyall,
        icon: IconReplyall,
        width: 840,
        height: 840,
    },
    {
        id: 'scooter',
        label: 'Sur la piste cyclable',
        image: ImageScooter,
        icon: IconScooter,
        width: 840,
        height: 840,
    },
    {
        id: 'tupperware',
        label: 'Puanteurs variées',
        image: ImageTupperware,
        icon: IconTupperware,
        width: 840,
        height: 840,
    },
    {
        id: 'versions',
        label: 'Maquette final final 2',
        image: ImageVersions,
        icon: IconVersions,
        width: 840,
        height: 840,
    },
    {
        id: 'wetransfer',
        label: 'Tu es en retard',
        image: ImageWetransfer,
        icon: IconWetransfer,
        width: 840,
        height: 840,
    },
    {
        id: 'zoom',
        label: "T'es sur mute Monique",
        image: ImageZoom,
        icon: IconZoom,
        width: 840,
        height: 840,
    },
    {
        id: 'martineau',
        label: 'Gros beef contre URBANIA',
        image: ImageMartineau,
        icon: IconMartineau,
        width: 840,
        height: 840,
    },
    {
        id: 'poilievre',
        label: 'Le GROS BON SENS',
        image: ImagePoilievre,
        icon: IconPoilievre,
        width: 840,
        height: 840,
    },
    {
        id: 'northvolt',
        label: 'La filière ...',
        image: ImageNorthvolt,
        icon: IconNorthvolt,
        width: 840,
        height: 840,
    },
    {
        id: 'panierbleu',
        label: 'R.I.P.',
        image: ImagePanierBleu,
        icon: IconPanierBleu,
        width: 840,
        height: 840,
    },
];
